import type { ReactNode } from 'react';

interface StatCardProps {
  label: string;
  icon: ReactNode;
  value: string;
  delta: string;
  deltaUp?: boolean;
  sparkPath: string;
}

export function StatCard({ label, icon, value, delta, deltaUp, sparkPath }: StatCardProps) {
  return (
    <div className="stat">
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.45rem',
        fontFamily: 'var(--font-mono)',
        fontSize: '0.68rem',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: 'var(--app-muted)',
        marginBottom: '0.7rem',
      }}>
        <span style={{ color: 'var(--copper-300)', display: 'flex' }}>{icon}</span>
        {label}
      </div>

      <div style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 580,
        fontSize: '2.2rem',
        color: '#fff',
        lineHeight: 1,
        letterSpacing: '-0.02em',
        fontVariantNumeric: 'tabular-nums',
      }}>
        {value}
      </div>

      <div style={{
        fontFamily: 'var(--font-mono)',
        fontSize: '0.72rem',
        marginTop: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.3rem',
        color: deltaUp ? '#A7C97A' : 'var(--app-muted)',
      }}>
        {delta}
      </div>

      <svg className="stat__spark" viewBox="0 0 90 42" fill="none" preserveAspectRatio="none">
        <path d={sparkPath} stroke="#E2A56B" strokeWidth="2" />
      </svg>
    </div>
  );
}
